import React from "react";
import { Chip, Typography } from "@mui/material";

export const ExpenseTypeColumns = () => [
    {
        id: "name",
        label: "Name",
        render: (value, row) => <Typography variant="body2" sx={{ fontWeight: 600 }}>{row.name || "—"}</Typography>,
    },
    {
        id: "code",
        label: "Code",
        render: (value, row) => <Typography variant="body2">{row.code || "—"}</Typography>,
    },
    {
        id: "sort_order",
        label: "Order",
        render: (value, row) => (
            <Typography variant="body2" sx={{ textAlign: "center" }}>
                {row.sort_order ?? 0}
            </Typography>
        ),
    },
    {
        id: "is_active",
        label: "Status",
        render: (value, row) => (
            <Chip
                size="small"
                color={row.is_active ? "success" : "default"}
                label={row.is_active ? "Active" : "Inactive"}
            />
        ),
    },
];
